<template>
  <div class="select-paginator">
    <label
      for="paginator"
      class="sr-only"
      >Seitenzahl auswählen:</label
    >
    <select
      id="paginator"
      class="select-paginator__input selectbox"
      @change="onSelect"
    >
      <option
        v-for="page in pages"
        :key="page"
        :value="page"
        :selected="page === currentPage"
      >
        {{ page }}
      </option>
    </select>
  </div>
</template>

<script>
import Paginator from '@/mixins/paginator';

export default {
  name: 'SelectPaginator',
  mixins: [Paginator],
  emits: ['click'],
  methods: {
    onSelect(event) {
      if (this.emitOnlyClick) {
        this.$emit('click', parseInt(event.target.value, 10));
      } else {
        const page = event.target.value;
        this.$router.push(this.url(page));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.select-paginator {
  display: flex;

  &__input {
    width: 88px;
  }
}
</style>
